import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";

import { authenticationService } from '../../services/authenticationService';

const LOGIN = "login";
const NEW_USER = "register";


const texts = {
    [LOGIN]: {
        header: "Welcome to MediaFlow Admin",
        generalError: "Username or password is invalid",
        formTitle: "Use a local account to sign in",
        loading: "Signing you in...",
        switchContextQuestion: "Don't have an account?",
        switchContext: "Create a new one here.",
        action: "Sign in"

    },
    [NEW_USER]: {
        header: "Create a new account",
        generalError: "Error creating your account",
        formTitle: "Please fill out this form to create your account",
        loading: "Creating your account...",
        switchContextQuestion: "Already have an account?",
        switchContext: "Sign in with your existing account.",
        action: "Create account"
    }
};


export const AccountHeader = ({pageContext}) => {
    return (<h2 className="text-light">{texts[pageContext].header}</h2>);
};

const Account = ({location, history, pageContext}) => {
    if ([LOGIN, NEW_USER].indexOf(pageContext) === -1) pageContext = LOGIN;

    const { register, handleSubmit, setFocus, watch, formState: { errors } } = useForm();
    const watchPassword = watch("password");

    const [pageState, setPageState] = useState({ loading: false, error: "" });
    const validations = {
        email: {
            required: "Email is required",
            maxLength: {
                value: 128,
                message: "Email cannot be longer than 128 characters"
            },
            validate: {
                email: value => !/^\S+@\S+$/i.test(value) ? "Please type a valid email" :
                    !/^\S+@yangaroo\.com$/i.test(value) ? "Please use yangaroo domain email" : true
            }
        },
        password: {
            maxLength: {
                value: 128,
                message: "Password cannot be longer than 256 characters"
            },
            minLength: {
                value: 8,
                message: "Password must have minimum of 8 characters"
            },
            required: "Password is required",
        },
        passwordConfirm: {
            validate: {
                passwordMatch: value => value === watchPassword || "The passwords must match"
            },
            required: "Password confirmation is required",
        }
    }

    useEffect(() => {
        if (authenticationService.currentUserValue) {
            history.push('/');
        }
        setFocus("email");
    }, [history, setFocus]);

    const onSubmit = (data) => {
        setPageState({ loading: true, error: "" });
        const func = (pageContext === LOGIN) ? authenticationService.login : authenticationService.register;

        func(data.email, data.password, data.passwordConfirm)
        .then(
            response => {
                if (pageContext === NEW_USER) history.push("/register/confirm", { user: response.username });
                else{
                    if (response) {
                        if (response.token) history.push((location.state && location.state.from) || "/");
                        else history.push("/register/confirm", { notApproved: true });
                    }
                    else setPageState({ loading: false, error: texts[pageContext].generalError });
                }
            },
            error => {
                setPageState({ loading: false, error: error });
            }
        );
    }

    return (<>
        <div className={pageState && pageState.loading ? "d-none" : "d-block"}>
            <div className="text-center text-muted mb-4">
                <p className="text-default text-sm">{texts[pageContext].formTitle}</p>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                {pageState && pageState.error && <div className="alert alert-danger validation-summary">{pageState.error}</div>}
                <div className="form-group">
                    <div className="input-group input-group-merge input-group-alternative">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><i className="fas fa-envelope-open"></i></span>
                        </div>
                        <input className="form-control" placeholder="Email"
                            {...register("email", validations.email)}
                        />
                    </div>
                    <small className="text-danger">
                        {errors.email && errors.email.message}
                    </small>
                </div>
                <div className="form-group">
                    <div className="input-group input-group-merge input-group-alternative">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><i className="fas fa-lock-open"></i></span>
                        </div>
                        <input className="form-control" placeholder="Password" type="password"
                            {...register("password", validations.password)}
                        />
                    </div>
                    <small className="text-danger">
                        {errors.password && errors.password.message}
                    </small>
                </div>
                {pageContext === NEW_USER && 
                <div className="form-group">
                    <div className="input-group input-group-merge input-group-alternative">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><i className="fas fa-lock-open"></i></span>
                        </div>
                        <input className="form-control" placeholder="Confirm your password" type="password"
                            {...register("passwordConfirm", validations.passwordConfirm)}
                        />
                    </div>
                    <small className="text-danger">
                        {errors.passwordConfirm && errors.passwordConfirm.message}
                    </small>
                </div>
                }
                <div className="text-center">
                    <input type="submit" className="btn btn-default mt-4" value={texts[pageContext].action} />
                </div>
            </form>
            <hr />
            <div className="text-center">
                <p className="text-default text-sm">{texts[pageContext].switchContextQuestion} <Link to={pageContext === LOGIN ? "/register" : "/login"} className="font-weight-bold">{texts[pageContext].switchContext}</Link></p>
            </div>
        </div>
        <div className={`text-center ${!(pageState && pageState.loading) ? "d-none" : "d-block"}`}>
            <div className="fa-3x">
                <i className="fas fa-spinner fa-spin"></i>
            </div>
            <p className="mb-0 mt-3">
                {texts[pageContext].loading}
            </p>
        </div>
    </>
    )
};

export default Account;